import * as React from 'react';
import {Text, TextPriority} from '@wix/wix-ui-tpa/cssVars';
import {classes, st} from './TotalsRow.st.css';
import {TotalsDataHook} from '../../Totals';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../../constants';

type RenderProp = () => React.ReactNode;
export interface TotalsRowProps {
  title: string | RenderProp;
  isSecondary?: boolean;
  value?: string | RenderProp;
  dataHook?: string;
  className?: string;
}

export const TotalsRow = ({title, value, className, dataHook, isSecondary}: TotalsRowProps) => {
  const {experiments} = useExperiments();
  const secondaryTitleOnly = experiments.enabled(SPECS.SecondaryTitleOnlyInTotalsRow);
  const valuePriority = isSecondary && !secondaryTitleOnly ? TextPriority.secondary : TextPriority.primary;

  return (
    <dl
      data-hook={dataHook ?? /* istanbul ignore next */ TotalsDataHook.TotalsRow}
      className={st(classes.root, className)}>
      <dt>
        {typeof title === 'string' ? (
          <Text
            priority={isSecondary ? TextPriority.secondary : TextPriority.primary}
            className={classes.totalTitleText}
            data-hook={TotalsDataHook.TotalsRowTitle}>
            {title}
          </Text>
        ) : (
          title()
        )}
      </dt>
      {value ? (
        <dd data-hook={TotalsDataHook.TotalsRowValue} className={classes.totalsRowValue}>
          {typeof value === 'string' ? (
            <Text
              data-hook={TotalsDataHook.TotalsRowValueText}
              priority={valuePriority}
              className={classes.totalTitleValue}>
              {value}
            </Text>
          ) : (
            value()
          )}
        </dd>
      ) : undefined}
    </dl>
  );
};

TotalsRow.displayName = 'Totals.TotalsRow';
